"use client"

import type { ComponentProps } from "react"
import type { FieldValues } from "react-hook-form"

import React, { useState } from "react"

import { InputField } from "#components/form/inputField"
import { useTranslation } from "#modules/localization/translations.client"
import SvgViewOff from "#svgs/semantic icons/ViewOff"

export function PasswordField<T extends FieldValues>({
  newPassword,
  ...restInputFieldProps
}: { newPassword: boolean; placeholder?: string } & Omit<ComponentProps<typeof InputField<T>>, "placeholder">) {
  const [passwordVisible, setPasswordVisible] = useState(false)

  const { t } = useTranslation("forms")

  return (
    <InputField
      type={passwordVisible ? "text" : "password"}
      placeholder={t("fields.password")}
      IconElement={<SvgViewOff onClick={() => setPasswordVisible(old => !old)} />}
      autoComplete={newPassword ? "new-password" : "current-password"}
      {...restInputFieldProps}
    />
  )
}
